module.exports = __webpack_public_path__ + "static/media/156-costa-rica.db9971e5.svg";